import moment from "moment";

import { Store } from "../../../../flux/Store";
import { Actions, createNamespace } from "../../../../flux/Actions";

const ns = createNamespace('DATE_RANGE');
export const names = {
    SET_FROM_DATE: ns('SET_FROM_DATE'),
    SET_TO_DATE: ns('SET_TO_DATE'),
};

export class DateRangeActions extends Actions
{
    setFromDate = (date: moment.Moment) => this.dispatch(names.SET_FROM_DATE, date);
    setToDate = (date: moment.Moment) => this.dispatch(names.SET_TO_DATE, date);
}

export interface DateRangeState
{
    fromDate: moment.Moment;
    toDate: moment.Moment;
}

export class DateRangeStore extends Store<DateRangeState>
{
    constructor()
    {
        super();
        this.state = { fromDate: null, toDate: null };
        this.register<moment.Moment>(names.SET_FROM_DATE, e => this.field({ fromDate: e.payload }));
        this.register<moment.Moment>(names.SET_TO_DATE, e => this.field({ toDate: e.payload }));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/DateRangeStore.ts